import { orchestrator } from 'satcheljs';
import { startShowCalendarFormPerfDatapoint } from '../actions/publicActions';
import { PerformanceDatapoint } from 'owa-analytics';
import { addCalendarFormPerfDatapoint } from '../mutators/perfDatapointMutators';

orchestrator(startShowCalendarFormPerfDatapoint, actionMessage => {
    const datapoint = new PerformanceDatapoint(actionMessage.datapointName);
    datapoint.addCustomData({
        component: actionMessage.component,
        popoutType: actionMessage.popoutType,
        bundleAlreadyLoaded: actionMessage.bundleAlreadyLoaded,
    });

    if (actionMessage.otherData) {
        datapoint.addCustomData(actionMessage.otherData);
    }

    addCalendarFormPerfDatapoint(actionMessage.formId, datapoint);
});
